export function ImgReturn({ size = 24 }: { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 511.999 511.999"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* 1️⃣ “R”‑like shape */}
      <path d="M210.188,91.3c0-10.221-8.286-18.507-18.507-18.507h-60.633c-10.221,0-18.507,8.286-18.507,18.507
                s8.286,18.507,18.507,18.507h60.633C201.902,109.807,210.188,101.521,210.188,91.3z" />
      {/* 2️⃣ Arrow‑like shape */}
      <path d="M93.923,298.809L12.359,345.9c-16.493,9.522-16.463,33.364,0,42.869l81.565,47.091
                c16.492,9.522,37.125-2.423,37.125-21.434v-94.183C131.049,301.2,110.388,289.302,93.923,298.809z" />
      {/* 3️⃣ Main body / container */}
      <path d="M353.754,72.795h-79.701c-10.518,0-18.987,8.773-18.486,19.401c0.469,9.954,9.044,17.612,19.009,17.612h80.9
                c66.292,0,120.149,54.253,119.505,120.689c-0.638,65.792-55.232,118.331-121.028,118.331h-185.89
                c-6.814,0-12.338,5.524-12.338,12.339v12.338c0,6.814,5.524,12.338,12.338,12.338h187.414
                c86.612,0,157.019-70.713,156.52-157.438C511.5,142.034,440.125,72.795,353.754,72.795z" />
    </svg>
  );
}